var plugin_default = {
  "alignLeft": "Ik8pK",
  "textWrapNowrap": "NtNUw",
  "alignRight": "U1e7f",
  "alignCenter": "odAbW",
  "sizeFullWidth": "_3XT4E",
  "renderedInTable": "A4ID1",
  "sizeOriginal": "v36De",
  "sizeContent": "_0P5jU",
  "sizeSmall": "Xq3fZ",
  "sizeSmallCenter": "w6QFZ",
  "flex": "NrnwV",
  "atomic": "_72eGU",
  "embed": "_18vC-",
  "horizontalScrollbar": "EwjhL",
  "pluginContainerMobile": "Ce-P5"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
